/* eslint-disable no-plusplus */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */

import { FormUtils, detectDevice, detectUniqueVisitor } from '../utils';
import uiUploader from '../../../shared/uploader';
import { fplsFetch } from '../../../shared/utils';
import {
  saveFormPaymentSubmissionId,
  updateFormGeolocation,
  saveFormPaymentError,
  updateFormAnalytics,
  setFormAnalytics,
  updateESign,
} from '../reducer/form';

const formUtils = new FormUtils();
const { inIframe, isSupport, getSessionInterval, startNewInterval, isOffline } = formUtils;

const onPosition = (position) => async (dispatch) => {
  dispatch(updateFormGeolocation({ lat: position.coords.latitude, lng: position.coords.longitude }));
};

const onPositionFail = () => console.error("Getting User's location failed");

export const getLocation = () => async (dispatch, getState) => {
  const { form } = getState().form;

  if (form.get_location) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => dispatch(onPosition(position)), onPositionFail, {
        enableHighAccuracy: true,
      });
    } else {
      console.error('Geolocation is not enabled on this browser');
    }
  }
};

export const sendAnalytics = () => async (dispatch, getState) => {
  const { form_analytics, form_id } = getState().form;
  // send analytics data to the server
  if (
    isSupport() ||
    (inIframe() &&
      (document.referrer.indexOf('formpl.us/control') > -1 || document.referrer.indexOf('formpl.us/r') > -1))
  ) {
    return;
  }
  await fplsFetch({
    method: 'POST',
    url: `/api/v2/public/forms/${form_id}/analytics`,
    data: form_analytics,
  })
    .then((res) => {
      if (res.status === 'OK') {
        dispatch(updateFormAnalytics({ key: 'session_id', value: res.session_id }));

        if (!getSessionInterval()) {
          // start polling server with `total timespent on form`
          startNewInterval();
        }
      }
    })
    .catch((error) => console.error('Send Analytics Error', error));
};

export const collectAnalytics = () => async (dispatch, getState) => {
  dispatch(getLocation());
  const { form_analytics, form_id } = getState().form;

  const updatedAnalytics = {
    ...form_analytics,
    form_id,
    current_user: window.OWNER,
    device: detectDevice(),
    unique_visit: detectUniqueVisitor(form_id),
  };
  dispatch(setFormAnalytics({ updatedAnalytics }));
  if (
    isSupport() ||
    (inIframe() &&
      (window.location.href.indexOf('formpl.us/control') > -1 || window.location.href.indexOf('formpl.us/r') > -1))
  ) {
    return;
  }
  dispatch(sendAnalytics());
};

export const onPaymentValueChange = () => (dispatch, getState) => {
  const { editableForm, form_id, savedFormPaymentSubmissionId } = getState().form;
  const data = {
    form_id,
    results: editableForm.definition.pages,
    respondent_email: editableForm.respondent_email,
    form_modified: editableForm.modified,
    saved_payment_submission_id: savedFormPaymentSubmissionId || '',
  };
  fplsFetch({
    method: 'PUT',
    url: `/api/v2/public/forms/${form_id}/payment/save_submission`,
    data,
    removeToken: true,
  })
    .then((response) => {
      if (response.error) {
        dispatch(saveFormPaymentError({ response }));
      } else {
        dispatch(saveFormPaymentSubmissionId({ response }));
      }
    })
    .catch((error) => {
      console.error('Payment save error:', error);
    });
};

export const uploadESignDocument = (document, onCompleted) => (dispatch, getState) => {
  const errorMessages ={
    unknown: `Submission Failed! Kindly retry and if this issue persists, ask form owner to contact support@formpl.us`,
    offline: 'Upload Timed Out! Kindly check your computer’s internet connection and try again',
    aborted: 'Document upload was cancelled'
  };

  const { auditTrail } = getState().form.eSign;
  const uploader = new uiUploader();
  const isNoInternet = isOffline();
  dispatch(updateESign({
    isLoading: true,
    error: ''
  }));
  
  uploader.addFiles([document]);
  uploader.startUpload({
    url: `/api/v2/public/e_signature/${auditTrail.id}`,
    fileKey: 'document',
    concurrency: 1,
    onProgress(subs) {
      setTimeout(() => {
        if (isNoInternet) dispatch(updateESign({
          error: errorMessages.offline
        }));
      }, 500);
    },
    onCompleted() {
      dispatch(updateESign({
        auditTrail: { ...auditTrail, signed: true },
        isLoading: false,
        error: ''
      }));
      onCompleted(true);
    },
    onError(err) {
      let error = errorMessages.unknown;
      if (err === 'request_aborted') {
        error = errorMessages.aborted;
      } else if (isNoInternet) {
        error = errorMessages.offline;
      }

      console.error('E-Sign document upload error: ', err);
      dispatch(updateESign({
        auditTrail: { ...auditTrail, signed: false },
        isLoading: false,
        error
      }));
      
      uploader.removeFile(document);
    }
  });
};

export const getESignAuditTrail = () => (dispatch, getState) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  const { eSign: { auditTrail }, form_id } = getState().form;
  const { email, name } = auditTrail;

  dispatch(updateESign({ isLoading: false }));

  fplsFetch({
    url: `/api/v2/public/e_signature`,
    removeToken: true,
    method: 'POST',
    data: {
      timezone,
      form_id,
      email,
      name
    },
  })
  .then((response) => {
    if (response.error) return dispatch(updateESign({
      error: response?.error ?? 'An error occurred',
      isLoading: false
    }));

    dispatch(updateESign({
      auditTrail: { ...auditTrail, ...response },
      isLoading: false,
      error: ''
    }));
  })
  .catch((error) => {
    console.error('E-Sign audit trail error:', error);
  });
};